import React from 'react';
import FormRow from 'vkid-ui/lib/Components/FormRow/index';
import FormRowGroup from 'vkid-ui/lib/Components/FormRowGroup';
import ControlInput from 'vkid-ui/lib/Components/ControlInput';
import ButtonIcon from 'vkid-ui/lib/Components/ButtonIcon';
import { useTranslation } from 'react-i18next';

interface IProps {
    iban: string;
    setIban: (str: string) => void;
    ibanName: string;
    setIbanName: (str: string) => void;
    ibanError: boolean;
    ibanNameError: boolean;
}

const BuyBackIbanForm = (props: IProps) => {
    const { t } = useTranslation();

    const { iban, setIban, ibanName, setIbanName, ibanError, ibanNameError } = props;

    return (
        <>
            <p>
                <b>{t('Buy Back Data')}</b>
            </p>
            <FormRow
                label={t('Iban')}
                required={true}
                labelFor="iban"
                error={ibanError ? t('This is a required field') : ''}
            >
                <FormRowGroup>
                    <ControlInput
                        id="iban"
                        name="iban"
                        value={iban}
                        onChange={(e) => {
                            setIban(e.target.value ?? '');
                        }}
                    />
                    <ButtonIcon icon="question" intent="link" tooltip={t('Required for buy back')} />
                </FormRowGroup>
            </FormRow>
            <FormRow
                label={t('Iban name')}
                required={true}
                labelFor="ibanowner"
                error={ibanNameError ? t('This is a required field') : ''}
            >
                <FormRowGroup>
                    <ControlInput
                        id="iban_name"
                        name="iban_name"
                        value={ibanName}
                        onChange={(e) => {
                            setIbanName(e.target.value ?? '');
                        }}
                    />
                    <ButtonIcon icon="question" intent="link" tooltip={t('required for buy back')} />
                </FormRowGroup>
            </FormRow>
        </>
    );
};

export default BuyBackIbanForm;
